import React from "react";

const Bar = ({ className = "" }) => (
  <div className={`animate-pulse rounded bg-cloud-mist ${className}`} />
);

/** Placeholder card with the same geometry as BlogCard. */
const BlogCardSkeleton = () => (
  <div
    aria-hidden="true"
    className="h-full overflow-hidden rounded-2xl border border-hairline bg-surface-white shadow-comfort"
  >
    <div className="relative aspect-[16/10] bg-surface-light">
      <Bar className="absolute left-4 top-4 h-6 w-28 rounded-full" />
    </div>

    <div className="flex flex-col p-5 sm:p-6">
      <div className="mb-3 flex items-center gap-2">
        <Bar className="h-4 w-4" />
        <Bar className="h-4 w-40" />
      </div>

      <div className="mb-3 flex flex-col gap-2">
        <Bar className="h-6 w-full" />
        <Bar className="h-6 w-2/3" />
      </div>

      <div className="mb-6 flex flex-col gap-2">
        <Bar className="h-4 w-full" />
        <Bar className="h-4 w-full" />
        <Bar className="h-4 w-4/5" />
        <Bar className="h-4 w-2/5" />
      </div>

      <div className="mt-auto flex items-center justify-between gap-3 border-t border-cloud-mist pt-3">
        <Bar className="h-4 w-24" />
        <Bar className="h-4 w-4 rounded-full" />
      </div>
    </div>
  </div>
);

const BlogSkeleton = ({ count = 6 }) => (
  <div aria-busy="true" className="grid grid-cols-1 gap-6 md:grid-cols-2 md:gap-8 lg:grid-cols-3">
    <p className="sr-only">Loading blogs…</p>
    {Array.from({ length: count }, (_, i) => (
      <BlogCardSkeleton key={i} />
    ))}
  </div>
);

export default BlogSkeleton;
